import React, { Component } from "react";
import "./Signup.css";
import { Link, Redirect } from "react-router-dom";
import { CLIENT, GOOGLE_AUTH_URL, TWITTER_AUTH_URL } from "../../constants";
import { getClientInfo, signup } from "../../util/APIUtils";
import googleLogo from "../../img/google-logo.png";
import Alert from "react-s-alert";
import TwitterLogo from "../../img/Twitter-X.png";
import { getUrlParameter } from "../../util/DataUtils";

class Signup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      client: null,
      clientName: "",
    };
  }

  componentWillMount() {
    // const clientId = getUrlParameter(CLIENT, window.location.search);
    const searchParams = new URLSearchParams(window.location.search);
    const clientIdURL = searchParams.get("client");
    if (clientIdURL) {
      getClientInfo(clientIdURL)
        .then((response) => {
          this.setState({
            client: { ...response },
          });

          this.setState({
            clientName: response.name,
          });

          localStorage.setItem(CLIENT, JSON.stringify(response));
        })
        .catch((error) => {
          this.setState({
            client: null,
          });
          console.log(error);
        });
    } else {
      var client = JSON.parse(localStorage.getItem(CLIENT));
      if (client != null) {
        this.setState({
          client: client,
        });
        this.setState({
          clientName: client.name,
        });
      }
    }
  }
  render() {
    if (this.props.authenticated) {
      return (
        <Redirect
          to={{
            pathname: "/",
            state: { from: this.props.location },
          }}
        />
      );
    }

    return (
      <div className="signup-container">
        <div className="signup-content">
          <h1 className="signup-title">Signup with {this.state.clientName}</h1>
          <SocialSignup />
          <div className="or-separator">
            <span className="or-text">OR</span>
          </div>
          <SignupForm {...this.props} />
          <span className="login-link">
            Already have an account? <Link to="/login">Login!</Link>
          </span>
        </div>
      </div>
    );
  }
}

class SocialSignup extends Component {
  render() {
    return (
      <div className="social-signup">
        <a className="btn btn-block social-btn google" href={GOOGLE_AUTH_URL}>
          <img src={googleLogo} alt="Google" /> Sign up with Google
        </a>
        <a className="btn btn-block social-btn twitter" href={TWITTER_AUTH_URL}>
          <img src={TwitterLogo} alt="Twitter" /> Log in with Twitter
        </a>
      </div>
    );
  }
}

class SignupForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      email: "",
      password: "",
      clientId: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    // this.loadCurrentlyClient = this.loadCurrentlyClient.bind(this);
  }

  componentWillMount() {
    // const clientId = getUrlParameter(CLIENT, window.location.search);
    const searchParams = new URLSearchParams(window.location.search);
    const clientIdURL = searchParams.get("client");
    if (clientIdURL) {
      getClientInfo(clientIdURL)
        .then((response) => {
          this.setState({
            clientId: response.clientId,
          });
          localStorage.setItem(CLIENT, JSON.stringify(response));
        })
        .catch((error) => {
          this.setState({
            clientId: null,
          });
          console.log(error);
        });
    } else {
      var client = JSON.parse(localStorage.getItem(CLIENT));
      console.log(client);
      if (client != null) {
        this.setState({
          clientId: client.clientId,
        });
      }
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const inputName = target.name;
    const inputValue = target.value;

    this.setState({
      [inputName]: inputValue,
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const signUpRequest = Object.assign({}, this.state);

    signup(signUpRequest)
      .then((response) => {
        Alert.success(
          "You're successfully registered. Please check your email to verify your account!"
        );
        // this.props.history.push("/login");
        this.props.history.push("/registration-success");
      })
      .catch((error) => {
        Alert.error(
          (error && error.message) ||
            "Oops! Something went wrong. Please try again!"
        );
      });
  }

  render() {
    return (
      <form onSubmit={this.handleSubmit}>
        <div className="form-item">
          <input
            type="text"
            name="name"
            className="form-control"
            placeholder="Name"
            value={this.state.name}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="form-item">
          <input
            type="email"
            name="email"
            className="form-control"
            placeholder="Email"
            value={this.state.email}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="form-item">
          <input
            type="password"
            name="password"
            className="form-control"
            placeholder="Password"
            value={this.state.password}
            onChange={this.handleInputChange}
            required
          />
        </div>
        <div className="form-item">
          <button type="submit" className="btn-8">
            <span>Sign Up</span>
          </button>
        </div>
      </form>
    );
  }
}

export default Signup;



// WEBPACK FOOTER //
// ./src/user/signup/Signup.js